import { render, staticRenderFns } from "./PriceTypeDropdownField.vue?vue&type=template&id=479bbf1c"
import script from "./PriceTypeDropdownField.vue?vue&type=script&lang=ts"
export * from "./PriceTypeDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('479bbf1c')) {
      api.createRecord('479bbf1c', component.options)
    } else {
      api.reload('479bbf1c', component.options)
    }
    module.hot.accept("./PriceTypeDropdownField.vue?vue&type=template&id=479bbf1c", function () {
      api.rerender('479bbf1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/PriceTypeDropdownField.vue"
export default component.exports